/* eslint-disable no-console */
/**
 * i18n 中间件配置常量
 */

// 缓存配置
const CACHE_CONFIG = {
  URL_TTL: 5 * 60 * 1000, // CDN URL 缓存：5 分钟（词条更新后最多 5 分钟生效）
  MAX_SIZE: 100, // 最大缓存数量（只缓存 URL，占用很小）
  CLEANUP_THRESHOLD: 150, // 触发清理的阈值
};

// 超时配置
const TIMEOUT_CONFIG = {
  API: 5000, // API 请求超时：5 秒
  CDN: 5000, // CDN 请求超时：5 秒
};

// 语言标识映射（Next.js locale → CMS 语言标识）
const LANG_MAP = {
  ind: 'id', // 印尼文：Next.js 使用 'ind'，CMS 使用 'id'
};

// Next.js 支持的 locales（与 next.config.js 保持一致）
const SUPPORTED_LOCALES = ['en', 'zh', 'jp', 'ko', 'pt', 'ind'];

/**
 * 语言包 RouteId 映射表
 *
 * 结构：{
 *   [namespace]: {
 *     dev: routeId,   // 开发/测试环境的 CMS routeId
 *     prod: routeId,  // 生产/预发布环境的 CMS routeId
 *   }
 * }
 *
 * 注意：
 * 1. 开发环境（dev/test）使用 dev 配置
 * 2. 生产环境（prod/pre）使用 prod 配置
 * 3. 添加新语言包时，请在下方补充对应的 routeId
 */
const ROUTE_ID_MANIFEST = {
  // 公共语言包
  common: {
    dev: 3103,
    prod: 3626, // cms 40
  },

  // 文档中心
  'portal-document': {
    dev: 3105,
    prod: 3628, // cms 102
  },
  document: {
    dev: 3104,
    prod: 3627, // cms 30
  },

  // 首页
  home: {
    dev: 3108,
    prod: 3634,
  },

  // 运营活动
  'portal-operational': {
    dev: 3125,
    prod: 3650,
  },

  // 云市场
  'cloud-market': {
    dev: 3124,
    prod: 3646,
  },
};

/**
 * 根据环境获取 manifest 配置
 * @param {string} env - 环境标识（'dev', 'test', 'prod', 'pre'）
 * @param {string[]} namespaces - 需要的语言包命名空间列表
 * @returns {Object} manifest 配置对象
 */
function getManifest(env, namespaces) {
  const isProd = ['prod', 'pre'].includes(env);
  const manifest = {};

  namespaces.forEach((ns) => {
    const config = ROUTE_ID_MANIFEST[ns];
    if (config) {
      manifest[ns] = { routeId: isProd ? config.prod : config.dev };
    } else {
      console.warn(`[i18n-middleware] Warning: No routeId found for namespace "${ns}"`);
    }
  });

  return manifest;
}

module.exports = {
  CACHE_CONFIG,
  TIMEOUT_CONFIG,
  LANG_MAP,
  SUPPORTED_LOCALES,
  ROUTE_ID_MANIFEST,
  getManifest,
};
